import { render, staticRenderFns } from "./zg.vue?vue&type=template&id=93a76930&scoped=true"
import script from "./zg.vue?vue&type=script&lang=js"
export * from "./zg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93a76930",
  null
  
)

export default component.exports